import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as postActions from '../../../store/action/post'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { renderFormField, renderTextAreaField } from '../../../utils/reduxField'
import { DraggableAreasGroup } from 'react-draggable-tags'
import * as _ from 'lodash'
import Select from 'react-select'
import CreatorItemTrending from './CreatorItemTrending';
// import TagRecommendation from 'src/components/posts/tab/tag-recommendation';
const group = new DraggableAreasGroup();
const DraggableArea1 = group.addArea();
const DraggableArea2 = group.addArea();
class TrendingTag extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tagsTrending: props.tags || [],
            primary_category: props.primary_category || null
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { tags: nextCurrentTags, primary_category: nextCurrentCate } = nextProps;
        let { tagsTrending, primary_category } = this.state;

        if(tagsTrending != nextCurrentTags){
            this.setState({tagsTrending: nextCurrentTags});
        }
        if(primary_category != nextCurrentCate){
            this.setState({primary_category: nextCurrentCate});
        }
        
    }
  
    render() {
        const {layoutName, tags} = this.props;
        let { tagsTrending } = this.state;
        return (
            <div className={(layoutName !== 'layout-pc' ? 'row card' : '')}>
                {
                    layoutName !== 'layout-pc' &&
                    <div className={"card-header col-12 " + (checkClass)}>
                        <h4 className="card-title">Tag</h4>
                        <div className="card-tools">
                            <button type="button" className="btn btn-tool" data-card-widget="collapse">
                                <i className="fas fa-minus"></i>
                            </button>
                        </div>
                    </div>
                }

                <div className="card-body col-12">
                    <CreatorItemTrending primary_category={this.state.primary_category} creatable={false} functioncreate="createNewTag" functioncall="getListTag" newapi="/tags" valueinstore="listTags" posttype="tags"
                        type="tags" selectedValue={this.state.tagsTrending} isClearable={true} label="Chọn tag cho trang chủ (Tối thiểu 3 tag)" placeholder="Chọn tag cho trang chủ" ismulti={true} />
                </div>


            </div>


        )
    }

};

export default connect(store => {
    return {
    };
}, dispatch => {
    return {
        
    }
})(TrendingTag)
